module.exports = __webpack_public_path__ + "static/media/book14.62ddd536.jpg";